<template>
  <generic-modal :title="$t('payment schedule')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("loan") }} <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="{ 'is-danger': !meta.loan_id }"
              >
                <select v-model="meta.loan_id">
                  <option value="">{{ $t("select loan") }}</option>
                  <option
                    v-for="loan in loans"
                    :key="loan.value"
                    :value="loan.value"
                  >
                    {{ loan.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("payment number") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.payment_number"
                :class="{ 'is-danger': !meta.payment_number }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("due date") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="date"
                class="input"
                v-model="meta.due_date"
                :class="{ 'is-danger': !meta.due_date }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("payment date") }}</label>
            <div class="control">
              <input type="date" class="input" v-model="meta.payment_date" />
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label"
          >{{ $t("amount") }} <span class="has-text-danger">*</span></label
        >
        <div class="control">
          <input
            type="number"
            class="input"
            v-model="meta.amount"
            step="0.01"
            :class="{ 'is-danger': !meta.amount }"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("principal amount") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.principal_amount"
                step="0.01"
                :class="{ 'is-danger': !meta.principal_amount }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("interest amount") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.interest_amount"
                step="0.01"
                :class="{ 'is-danger': !meta.interest_amount }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("remaining balance") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.remaining_balance"
                step="0.01"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("late fee") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.late_fee"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("status") }} <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="{ 'is-danger': !meta.status }"
              >
                <select v-model="meta.status">
                  <option value="">{{ $t("select status") }}</option>
                  <option value="pending">{{ $t("pending") }}</option>
                  <option value="paid">{{ $t("paid") }}</option>
                  <option value="overdue">{{ $t("overdue") }}</option>
                  <option value="partial">{{ $t("partial") }}</option>
                  <option value="skipped">{{ $t("skipped") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("paid amount") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.paid_amount"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("notes") }}</label>
        <div class="control">
          <textarea class="textarea" v-model="meta.notes" rows="3"></textarea>
        </div>
      </div>
    </form>

    <div class="notification is-danger" v-if="error">
      {{ error }}
    </div>

    <template v-slot:footer>
      <button
        class="button is-success"
        @click="save"
        :disabled="is_form_invalid"
      >
        {{ $t("save") }}
      </button>
      <button class="button" @click="close_modal">
        {{ $t("cancel") }}
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { generate_error_message_text, del, post, put, get } from "@/utils";

export default {
  name: "PaymentScheduleModal",
  components: { GenericModal },
  data() {
    let v = this;
    return {
      meta: {
        status: "pending",
        late_fee: 0,
        paid_amount: 0,
        remaining_balance: 0,
      },
      error: "",
      schedule_uuid: "",
      is_clone: false,
      loans: [],
    };
  },
  computed: {
    is_form_invalid() {
      return (
        !this.meta.loan_id ||
        !this.meta.payment_number ||
        !this.meta.due_date ||
        !this.meta.amount ||
        !this.meta.principal_amount ||
        !this.meta.interest_amount ||
        !this.meta.status
      );
    },
  },
  methods: {
    show_modal(uuid = null, clone = false) {
      let v = this;
      v.schedule_uuid = uuid;
      v.is_clone = clone;
      v.$refs.generic_modal.show_modal();
      v.load_catalogs();
      if (uuid) {
        v.get_payment_schedule(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      if (v.schedule_uuid && !v.is_clone) {
        data.uuid = v.schedule_uuid;
        post("/loan/payment-schedule", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/loan/payment-schedule", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    get_payment_schedule(uuid) {
      let v = this;
      get("/loan/payment-schedule", { uuid: uuid })
        .then((response) => {
          v.meta = response.data;
          if (v.is_clone) {
            delete v.meta.uuid;
            v.meta.status = "pending";
            v.meta.payment_date = null;
            v.meta.paid_amount = 0;
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    load_catalogs() {
      let v = this;
      // Load loans
      get("/loan/loan/catalog")
        .then((response) => {
          v.loans = response.data;
        })
        .catch((error) => {
          console.error("Error loading loans:", error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        status: "pending",
        late_fee: 0,
        paid_amount: 0,
        remaining_balance: 0,
      };
      v.error = "";
      v.schedule_uuid = "";
      v.is_clone = false;
      v.loans = [];
    },
  },
};
</script>
